import styles from './AssignerToggles.module.scss'

import { PRIOR_LANE_LABEL } from '@/pages/app/AttributionViewer/relabelerLanes'

export function AssignerToggles({
  showFinal,
  onShowFinal,
  hasUserLabels,
  showPrior,
  onShowPrior,
}: {
  showFinal: boolean
  onShowFinal: (checked: boolean) => void
  hasUserLabels: boolean
  showPrior: boolean
  onShowPrior: (checked: boolean) => void
}) {
  return (
    <div className={styles.toggles} role="group" aria-label="Assigner lanes">
      <label className={styles.option} title="Controls the Final swimlane; the transcript column and legend keep Final">
        <input type="checkbox" checked={showFinal} onChange={(event) => onShowFinal(event.target.checked)} />
        Final: user-labeled
      </label>
      {hasUserLabels && (
        <label
          className={styles.option}
          title="The speaker labels refine shipped, before anyone set a speaker in the app"
        >
          <input type="checkbox" checked={showPrior} onChange={(event) => onShowPrior(event.target.checked)} />
          {PRIOR_LANE_LABEL}
        </label>
      )}
    </div>
  )
}
